module.exports = __webpack_public_path__ + "static/img/kundan-logo.8958aa6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kundan-logo.png
// module id = 181
// module chunks = 1